import Vue from 'vue'
import Vuex from 'vuex'
import data from './data'
import _ from 'lodash'
import { getIsIndexStock } from '../utils/formatStockInfo'

import {common} from './modules'

Vue.use(Vuex)
let userInfo = {
  token: '',
  headImage: '',
  serverId: '',
  nickname: '',
  username: ''
}
if (sessionStorage.getItem('userInfo')) {
  userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
}
const store = new Vuex.Store({
  state: {
    code: '',
    symbol: '',
    market: '',
    region: '', // HK, USA, CN
    isIndex: false,
    status: -1,
    dyna: {},
    statistic: {},
    profile: {},
    tick: [],
    tickBase: undefined,
    statics: {},
    stockname: '',
    homeScrollTop: 0,
    userInfo,
    homeAdList: []
  },
  mutations: {
    setHomeScrollTop(state, val) {
      state.homeScrollTop = val
    },
    setHomeAdvertisement(state, list) {
      state.homeAdList = list
    },
    setSymbol(state, {code, market}) {
      store.commit('setRegion', market)
      code = code.toLocaleUpperCase()
      state.symbol = code
      // code = state.region === 'HK' && code[0] !== '.' ? code.substring(1) : code
      // console.log('-------state.indexs[code]', state.indexs[code])
      if(state.code !== code) {
        state.common.tabs.map(tab => {
          tab.pageNo = 0
          tab.list = []
          return tab
        })
      }
      state.code = code
      state.market = market
      state.tickBase = undefined
      state.tick = []
      store.commit('setRegion', market)
      // console.log('state.indexs[code]', state.indexs[code])
      if (getIsIndexStock(code.toLowerCase(), market)) {
        state.isIndex = true
        state.common.tabs = [
          {
            label: '资讯',
            list: [],
            pageNo: 0,
            pageSize: 20,
            key: 'zixun'
          },
          {
            label: '股圈',
            key: 'guba',
            list: [],
            pageNo: 1,
          }
        ]
      } else {
        if (state.region !== 'CN') {
          state.common.tabs = [
            {
              label: '资讯',
              list: [],
              pageNo: 0,
              pageSize: 20,
              key: 'zixun'
            },
            {
              label: '公告',
              list: [],
              pageNo: 0,
              pageSize: 20,
              key: 'gonggao'
            },
            {
              label: '简况',
              list: [],
              pageNo: 0,
              key: 'jiankuang'
            },
            {
              label: '财务',
              key: 'caiwu'
            },
            {
              label: '股圈',
              key: 'guba',
              list: [],
              pageNo: 1,
            }
          ]
        }
      }
      store.commit('setRegion', market)
      console.log('code12312', code, market, state.region)
      data.subscribe(code, market, state.region)
    },
    setRegion (state, market) {
      market = market.toLocaleUpperCase()
      switch(market) {
        
        case 'HK':
        case 'HKSE':
        case 'HKIDX':
          state.region = 'HK'
          break
        case 'NYSE':
        case 'NASDAQ':
        case 'AMEX':
          state.region = 'USA'
          break
        default:
          state.region = 'CN'
      }
    },
    setStockName(state, name) {
      state.stockname = name
      window.document.title = name || '九方智投'
    },
    setStatus (state, type) {
      if(state.status !== type && state.status !== -1) {
        setTimeout(() => {
          window.location.reload()
        }, 60000)
      }
      state.status = type
    },
    setStatistics (state, obj) {
      state.statistic = obj
    },
    setDyna (state, obj) {
      state.dyna = obj
    },
    setTick (state, arr) {
      state.tick.push(...arr)
    },
    setTickBase(state, val) {
      state.tickBase = val
    },
    setProfile(state, obj) {
      state.profile = obj
    },
    setStatic(state, obj) {
      state.statics = obj
    },
    setUserInfo(state, obj) {
      state.userInfo = obj
      sessionStorage.setItem('userInfo', JSON.stringify(obj))
    }
  },
  modules: {
    common,
  }
})

export default store
